module.exports = __webpack_public_path__ + "img/slider_10.72ccafb8.jpg";